// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      minWidth: 42,
      height: 42,
      background: ' #F5F8FA',
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
    },
  }),
);

export default useStyles;
